module.exports = __webpack_public_path__ + "static/media/barre.29b071db.svg";